module.exports = "<slot _v-98bc4b82=\"\"></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/template-rewriter.js?id=_v-98bc4b82&file=TabGroup.vue!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/TabGroup.vue
// module id = 208
// module chunks = 0